import React, { useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import VideoPlayerModal from '../../common/VideoPlayerModal';
import ImageViewer from '../../common/ImageViewer';

const VRTraining = () => {
    const [modalShow, setModalShow] = useState(false);
    const [videoUrl, setVideoUrl] = useState(null)
    const [imageUrl, setImageUrl] = useState(null)
    const [chooseModal, setChooseModal] = useState(null)

    const imageDiv = []

    for (let index = 0; index < 18; index++) {

        imageDiv.push(
            <Col xs={{span:6, offset:0}} md={{span:4, offset:0}} className="no-padding-x" key={index}>
                <Card.Img onClick={() => openImageModal(index)} className='img img-thumbnail training-images' src={"/assets/vr-development/vr-trainings/equipment-operator/"+index+".jpg"} />
            </Col>
        )        
    }

    const openVideoModal = (data) => {
        setModalShow(true)
        setChooseModal('video')
        setVideoUrl(data)

    }

    const openImageModal = (data) => {
        setModalShow(true)
        setChooseModal('image')
        setImageUrl(data)
    }

  return (
    <>
        <Card className='text-center no-border rounded-0 industrial-modeling-top-section container'>
            <Card.Body>
                <Card.Title className='industrial-modeling-title'> VRトレーニング </Card.Title>
                <Card.Subtitle className="py-2 py-md-4 big-subtitle"> インパクトのある学習方法 </Card.Subtitle>
                <Card.Text className='industrial-environment-text text-left'>
                従来のトレーニング方法に比べ、イマーシブテクノロジーの利点は数多くあります。新入社員に対し、詳細かつリアルなデモンストレーションや、滅多に起こらない（あるいは起こしてはならない）状況のシミュレーションを行うことができます。
                </Card.Text>

                <Row>
                    <Col xs={{span:12, offset:0}} md={{span:8, offset:2}}>
                        <Card className='no-border rounded-0 container healthcare-video-container product-video-section' onClick={() => openVideoModal('/assets/vr-development/vr-trainings/video/Dromex.mp4')}>
                            <Card.Img className='img img-thumbnail' src={"/assets/vr-development/vr-trainings/trainging-banner.jpg"} />
                            <Card.ImgOverlay className='playicon-overlay-center'>
                                <Card.Img src={"/assets/icons/video-player.png"} />
                            </Card.ImgOverlay>

                        </Card>
                    </Col>
                </Row>

                <Card.Subtitle className="industrial-modeling-subtitle py-4"> 危険な状況のシミュレーション </Card.Subtitle>
                <Card.Text className='industrial-environment-text text-left'>
                鉱山、建設現場、医療施設、救急隊員など、稀な危険な状況を想定した訓練が必要な場合があります。バーチャルリアリティを利用すれば、訓練生は安全なVRヘッドセットを装着してシミュレーション状況を体験することができます。訓練生は、コストやリスクを伴わずに対処方法や手順について学ぶことができます。
                </Card.Text>
                <Row>
                    <Col xs={{span:12, offset:0}} md={{span:6, offset:3}}>
                        <Card.Img className='img img-thumbnail' src={"/assets/vr-development/vr-trainings/harardious.jpg"} />
                    </Col>
                </Row>
                <Card.Subtitle className="industrial-modeling-subtitle py-4"> 機器オペレーターの研修 </Card.Subtitle>
                <Card.Text className='industrial-environment-text text-left'>
                新しい装置のオペレーターの訓練は、VRの主要な使用例です。トレーニングのために機械を停止させたり、高コストや危険な事故のリスクを冒したりすることなく、安全なシミュレーション環境で新しい機器の操作法を習得させることができます。
                </Card.Text>
                <Row className='px-md-4'>
                    {imageDiv}
                </Row>
            </Card.Body>
        </Card>
        
       
        {chooseModal === "video" && 
             <VideoPlayerModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                videosrc={videoUrl}
           />
        }

        {chooseModal === 'image' &&
            <ImageViewer 
                show={modalShow}
                onHide={() => setModalShow(false)}
                imagesrc={imageUrl}
                imagedir="assets/vr-development/vr-trainings/equipment-operator/enlarge/"
                imagecounter={17}
                mimetype='jpg'
            />
        }
    </>
  )
}

export default VRTraining
